export const MFA_ERROR_MESSAGES = {
  DEFAULT: 'Invalid or expired verification code. Please check and try again.',
  INVALID_CODE: 'Invalid or expired verification code. Please check and try again.',
  INVALID_FORMAT: 'Invalid verification code format. Please enter a valid 6-digit code.',
  TOO_MANY_ATTEMPTS: 'Too many attempts. Please wait a few minutes before trying again.',
  USER_NOT_FOUND: 'User not found. Please try logging in again.',
  SERVER_ERROR: 'Server error. Please try again in a moment.',
  VERIFICATION_FAILED: 'Verification failed. Please try again.',
  SEND_CODE_FAILED: 'Failed to send verification code',
  VERIFY_CODE_FAILED: 'Failed to verify code',
  MFA_REQUIRED: 'MFA verification required. Please verify your code again.',
} as const

const isSuccessMessage = (message: string): boolean => {
  const lowerMessage = message.toLowerCase()
  return lowerMessage.includes('successful') || 
         lowerMessage.includes('success') ||
         lowerMessage.includes('verified successfully')
}

export const getMfaErrorMessage = (error: any): string => {
  let extractedMessage: string | null = null
  let responseData: any = null
  
  if (error.response?._data) {
    responseData = error.response._data
    extractedMessage = responseData.message
  } else if (error.response?.data) {
    responseData = error.response.data
    extractedMessage = responseData.message
  } else if (error.data) {
    responseData = error.data
    extractedMessage = error.data.message
  } else if (error.message && 
      error.message !== MFA_ERROR_MESSAGES.VERIFY_CODE_FAILED && 
      error.message !== MFA_ERROR_MESSAGES.MFA_REQUIRED) {
    extractedMessage = error.message
  }
  
  if (extractedMessage) {
    const isSuccess = responseData?.success === true || isSuccessMessage(extractedMessage)
    if (!isSuccess) {
      return extractedMessage
    }
  }
  
  const status = error.status || error.response?.status
  
  switch (status) {
    case 400:
      return MFA_ERROR_MESSAGES.INVALID_CODE
    case 422:
      return MFA_ERROR_MESSAGES.INVALID_FORMAT
    case 429:
      return MFA_ERROR_MESSAGES.TOO_MANY_ATTEMPTS
    case 404:
      return MFA_ERROR_MESSAGES.USER_NOT_FOUND
    case 500:
      return MFA_ERROR_MESSAGES.SERVER_ERROR
    default:
      return MFA_ERROR_MESSAGES.DEFAULT
  }
}
